// reducers
function navigation(state = {}, action) {
  switch (action.type) {
    case 'BANNER_DATA_SUCCESS':
      return action.banner;
    case 'UPDATE_BANNER_BASED_ON_LOCALE':
      return updateBannerStateByLocale(state, action);
    default:
      return state;
  }
}

export function objectIsEmpty(obj = {}) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

function filterImageBasedOnLocation(action = {}, locationMedias = []) {
  let { payload: { pincode = '', city = '', state = '', zone = '' } = {} } = action;
  city = city.toLowerCase();
  state = state.toLowerCase();
  zone = zone.toLowerCase();
  let url = '';
  let modifyPath = '';
  if (!objectIsEmpty(action)) {
    for (let loc = 0; loc < locationMedias.length; loc++) {
      let { location = '', URL = '', bannerUrlLink = '' } = locationMedias[loc];
      location = location.toLowerCase();
      switch (location) {
        case city:
          return {
            modifyUrl: URL,
            modifyPath: bannerUrlLink
          };
        case state:
          url = URL;
          modifyPath = bannerUrlLink;
          break;
        case zone:
          if (!url) {
            url = URL;
            modifyPath = bannerUrlLink;
          }
      }
    }
    if (url) {
      return {
        modifyUrl: url,
        modifyPath
      };
    }
  }
}

function handleObjectBanner(item = {}, banner = {}, action = {}, key = '') {
  // banner = {
  //   ...banner,
  //   locationMedias: [
  //     {
  //        "URL": `${properties.getProperty('imageBaseUrl')}/medias/sys_master/images/images/h15/h22/8936441184286/21022019-D-MHP-BANNER1-TopBrands-min50.jpg`,
  //        "location": "SOUTH",
  //        "uid": "loc1"
  //     }
  //  ],
  // };
  const { imageUrl = '', locationMedias = [], bannerUrlLink = '' } = banner;
  if (locationMedias.length) {
    const { modifyUrl = '', modifyPath = '' } =
      filterImageBasedOnLocation(action, locationMedias) || {};
    return {
      ...item,
      [key]: {
        ...banner,
        imageUrl: modifyUrl || imageUrl,
        bannerUrlLink: modifyPath || bannerUrlLink
      }
    };
  }
  return {
    ...item
  };
}

const bannerJsonKey = {
  banner: (item, banner, action) =>
    !objectIsEmpty(banner) && handleObjectBanner(item, banner, action, 'banner'),
  heroBanner: (item, banner, action) =>
    !objectIsEmpty(banner) && handleObjectBanner(item, banner, action, 'heroBanner'),
  leftBanner: (item, banner, action) =>
    !objectIsEmpty(banner) && handleObjectBanner(item, banner, action, 'leftBanner'),
  middleBanner: (item, banner, action) =>
    !objectIsEmpty(banner) && handleObjectBanner(item, banner, action, 'middleBanner'),
  rightBanner: (item, banner, action) =>
    !objectIsEmpty(banner) && handleObjectBanner(item, banner, action, 'rightBanner'),
  viewAllUrlLinkPageContentDetails: (item, banner, action) =>
    !objectIsEmpty(banner) &&
    handleObjectBanner(item, banner, action, 'viewAllUrlLinkPageContentDetails')
};

function updateBannerStateByLocale(initialState = {}, action = {}) {
  const { pageDetails = [] } = initialState;
  const newPageDetails = pageDetails.map((item, index) => {
    const { bannerImageDetails = [] } = item;
    // check for banner, heroBanner, leftBanner, middlerBanner, rightBanner, viewAllUrlLinkPageContentDetails
    for (const bannerKey in item) {
      for (const custom in bannerJsonKey) {
        if (bannerKey === custom) {
          return bannerJsonKey[custom](item, item[bannerKey], action);
        }
      }
    }
    // Check for bannerImageDetails key
    if (bannerImageDetails.length) {
      const newBannerImageDetails = bannerImageDetails.map(item => {
        const { imageUrl = '', locationMedias = [], bannerUrlLink = '' } = item;
        if (locationMedias.length) {
          const { modifyUrl = '', modifyPath = '' } =
            filterImageBasedOnLocation(action, locationMedias) || {};
          return {
            ...item,
            imageUrl: modifyUrl || imageUrl,
            bannerUrlLink: modifyPath || bannerUrlLink
          };
        }
        return {
          ...item
        };
      });

      return {
        ...item,
        bannerImageDetails: newBannerImageDetails
      };
    }

    // If no key found from the mentioned key in json [banner, bannerImageDetails,heroBanner, leftBanner, middleBanner, rightBanner, viewAllUrlLinkPageContentDetails]

    return {
      ...item
    };
  });
  return {
    ...initialState,
    pageDetails: newPageDetails
  };
}

export default navigation;
